export default __webpack_public_path__ + "e13b3bc3f6c6e8a5475897753411a5c9.png";